import React from 'react';
import { useSelector } from 'react-redux';
import ActionCard, { ActionCardVariant } from 'components/Common/Cards/ActionCard';
import Skeleton from 'components/Common/Skeleton';
import { groupItemsBy } from 'utils/groupItemsBy';
import { getUpcomingLoanPayments } from 'selectors/getUpcomingLoanPayments';

import UpcomingGroup from './UpcomingGroup/UpcomingGroup';
import { useUpcomingData } from './useUpcomingData';
import { useUpcomingPayments } from './useUpcomingPayments';
import { useUpcomingLoanPayments } from './useUpcomingLoanPayments';

import styles from './UpcomingSection.module.scss';

interface UpcomingSectionProps {
  applicationId?: string;
}

const UpcomingSection: React.FC<UpcomingSectionProps> = ({ applicationId }) => {
  const upcomingDataItems = useUpcomingData();
  const upcomingPaymentItems = useUpcomingPayments();
  const upcomingLoanPaymentItems = useUpcomingLoanPayments(applicationId);
  const { isLoading: isLoadingLoanPayments } = useSelector(getUpcomingLoanPayments);

  const allItems = [...upcomingDataItems, ...upcomingPaymentItems, ...upcomingLoanPaymentItems];

  const groups = groupItemsBy(allItems, 'groupLabel');

  if (isLoadingLoanPayments) {
    return (
      <div className={styles.upcomingSection}>
        <p className={styles.sectionLabel}>Upcoming</p>
        <ActionCard variant={ActionCardVariant.White}>
          <div className={styles.skeletonContainer}>
            <div className={styles.skeletonItem}>
              <Skeleton width="30%" height="10px" />
              <Skeleton width="40%" height="22px" />
              <Skeleton width="50%" height="20px" />
            </div>
            <Skeleton width="35%" height="22px" />
          </div>
        </ActionCard>
      </div>
    );
  }

  if (!groups || groups.length === 0) return null;

  return (
    <div className={styles.upcomingSection}>
      <p className={styles.sectionLabel}>Upcoming</p>
      <ActionCard variant={ActionCardVariant.White}>
        <ul className={styles.container}>
          {groups.map((group, index) => (
            <UpcomingGroup key={index} group={group} />
          ))}
        </ul>
      </ActionCard>
    </div>
  );
};

export default UpcomingSection;
